import { NavItem } from '@/modules/core/nav/models/NavItem';
import AdvisorProBadge from '@/assets/illustrations/nav/advisor-pro-badge.svg';
import { NavItemBadge } from '@/modules/core/nav/constants/NavItemBadge';

export class NavItemBadgeFactory {
  getCustomBadgeSrc(item: NavItem): string {
    switch (item.customBadge) {
      case NavItemBadge.ADVISOR_PRO_BADGE:
        return AdvisorProBadge;
      default:
        return '';
    }
  }
}

export default new NavItemBadgeFactory();
